<div class="dialog-wrapper" id="contactDialog" *ngIf="isOpen">
    <section class="dialog" [ngClass]="{ enter: isOpen, exit: isClosing }">
        <a
            *ngIf="isMobile"
            tabindex="0"
            id="dialogButtonFocused"
            class="swipe-bar"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd()"
            (click)="onClose()"
            (keydown)="onKeyDownClose($event)"
        >
            Close
        </a>
        <button
            *ngIf="!isMobile"
            id="dialogButtonFocused"
            class="dialog-close"
            tabindex="0"
            (click)="onClose()"
        >
            Close
        </button>
        <span *ngIf="isPriceContactDialog" class="dialog-title"
            >Our team will contact you soon to customize your clean!</span
        >
        <span *ngIf="!isPriceContactDialog" class="dialog-title"
            >We will be in touch soon to find a date for your clean!</span
        >
        <form [formGroup]="contactForm">
            <div class="phone-block">
                <label
                    [ngClass]="{
                        'invalid-field': isPhoneInvalid
                    }"
                >
                    <span class="label required">Phone number</span>
                    <input
                        id="phone"
                        type="tel"
                        formControlName="phone"
                        required
                        aria-required="true"
                        [attr.aria-invalid]="isPhoneInvalid ? 'true' : 'false'"
                        [attr.aria-describedby]="isPhoneInvalid ? 'dialogPhone-error' : null"
                        [ngClass]="{
                            'warning-input': isPhoneInvalid
                        }"
                        tabindex="0"
                        mask="(000) 000-0000"
                        [dropSpecialCharacters]="true"
                        [showMaskTyped]="true"
                        placeholder="(___) ___-____"
                        [ngClass]="{
                            'warning-input': isPhoneInvalid
                        }"
                    />
                    <span id="dialogPhone-error" *ngIf="isPhoneInvalid" role="alert">
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('phone')?.hasError('minlength')"
                            >Please enter a 10-digit phone number.</span
                        >
                        <span
                            class="warning-text"
                            *ngIf="
                                contactForm.get('phone')?.hasError('repeatingDigitsPhone') &&
                                !contactForm.get('phone')?.hasError('minlength')
                            "
                            >Phone number can’t contain all the same digits</span
                        >
                    </span>
                </label>
            </div>
            <app-picker
                [pickerData]="contactData"
                [selectedValue]="selectedContactValue"
                (optionSelected)="onContactSelected($event)"
            ></app-picker>
            <div class="terms-holder">
                <input type="checkbox" id="terms" formControlName="terms" />
                <label
                    role="checkbox"
                    (keydown)="onKeyDownTermsPolicy($event)"
                    tabindex="0"
                    for="terms"
                    ><span
                        >I agree to the
                        <a target="_blank" [href]="data.termsOfUseUrl">Terms of Use</a><br />
                        and
                        <a target="_blank" [href]="data.privacyPolicyUrl">Privacy Policy.</a></span
                    ></label
                >
            </div>
            <div class="dialog-bottom">
                <button
                    tabindex="0"
                    (click)="onSave()"
                    [disabled]="contactForm.invalid"
                    class="dialog-btn"
                >
                    Let’s get in touch
                </button>
            </div>
        </form>
    </section>
    <div class="dialog-overlay" #overlay (click)="onClose()"></div>
</div>
